// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"pY-z","dimensionLabel":"qY-z","styleChooserControlWrapper":"rY-z","styleChooserControl":"sY-z","disabled":"tY-z","giftCard":"uY-z","styleChooserText":"vY-z"};